import React from "react";
import styles from "./date-range-controls.module.css";
import Button from "@/components/forms/Button/Button";

export enum ChartsDateRange {
  Hour = "H",
  Day = "D",
  Week = "W",
  Month = "M",
  AllTime = "ALL",
};

type DateRangeControlsProps = {
  range: "H" | "D" | "W" | "M" | "ALL";
  setRange: (value: ChartsDateRange) => void;
};

const DateRangeControls = ({
  range,
  setRange,
}: DateRangeControlsProps) => {

  const handleDataRangeChange = (r: ChartsDateRange) => {
    setRange(r);
  };

  return (
    <div className={styles.dataRangeControlsContainer}>
      <Button
        type={range === "H" ? "primary" : "secondary"}
        onClick={() => handleDataRangeChange(ChartsDateRange.Hour)}
      >
        {ChartsDateRange.Hour}
      </Button>
      <Button
        type={range === "D" ? "primary" : "secondary"}
        onClick={() => handleDataRangeChange(ChartsDateRange.Day)}
      >
        {ChartsDateRange.Day}
      </Button>
      <Button
        type={range === "W" ? "primary" : "secondary"}
        onClick={() => handleDataRangeChange(ChartsDateRange.Week)}
      >
        {ChartsDateRange.Week}
      </Button>
      <Button
        type={range === "M" ? "primary" : "secondary"}
        onClick={() => handleDataRangeChange(ChartsDateRange.Month)}
      >
        {ChartsDateRange.Month}
      </Button>
      <Button
        type={range === "ALL" ? "primary" : "secondary"}
        onClick={() => handleDataRangeChange(ChartsDateRange.AllTime)}
      >
        {ChartsDateRange.AllTime}
      </Button>
    </div>
  );
};

export default DateRangeControls;